import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcEmptyAnalysis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 91,
	height: 112,
	viewBox: "0 0 91 112",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M58.4383 23.9038C61.4868 23.9038 63.958 21.4326 63.958 18.3841C63.958 15.3356 61.4868 12.8643 58.4383 12.8643C55.3898 12.8643 52.9185 15.3356 52.9185 18.3841C52.9185 21.4326 55.3898 23.9038 58.4383 23.9038ZM58.4383 26.8223C63.0986 26.8223 66.8765 23.0444 66.8765 18.3841C66.8765 13.7237 63.0986 9.9458 58.4383 9.9458C53.7779 9.9458 50 13.7237 50 18.3841C50 23.0444 53.7779 26.8223 58.4383 26.8223Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M81.7346 16.1699C81.9765 15.3832 82.8104 14.9416 83.5971 15.1835C84.3838 15.4254 84.8255 16.2593 84.5836 17.046L83.0095 22.165L87.3781 23.5084C88.1648 23.7503 88.6065 24.5842 88.3645 25.3709C88.1226 26.1576 87.2888 26.5993 86.502 26.3573L82.1334 25.014L80.8599 29.1553C80.618 29.942 79.7842 30.3837 78.9974 30.1418C78.2107 29.8998 77.7691 29.066 78.011 28.2793L79.2845 24.1379L74.3927 22.6337C73.606 22.3918 73.1644 21.5579 73.4063 20.7712C73.6482 19.9845 74.4821 19.5429 75.2688 19.7848L80.1605 21.289L81.7346 16.1699Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M76.9677 1.68088C76.7257 -0.0680111 74.4669 -0.616473 73.4499 0.826735L72.9447 1.54362C72.6342 1.98424 72.1548 2.2763 71.6209 2.35017L70.7522 2.47034C69.0033 2.71228 68.4548 4.97109 69.898 5.9881L70.6149 6.49328C71.0555 6.80378 71.3476 7.28315 71.4215 7.8171L71.5416 8.68583C71.7836 10.4347 74.0424 10.9832 75.0594 9.53997L75.5646 8.82309C75.8751 8.38247 76.3544 8.09041 76.8884 8.01654L77.7571 7.89637C79.506 7.65443 80.0545 5.39562 78.6113 4.37861L77.8944 3.87343C77.4538 3.56293 77.1617 3.08356 77.0878 2.54961L76.9677 1.68088Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.01758 43.7141C7.01758 38.5885 11.1727 34.4333 16.2983 34.4333H60.883C66.0086 34.4333 70.1638 38.5885 70.1638 43.7141V102.331C70.1638 107.457 66.0086 111.612 60.883 111.612H16.2983C11.1727 111.612 7.01758 107.457 7.01758 102.331V43.7141Z",
			fill: "#CED2DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M58.0057 52.9964C58.0057 53.7652 57.3824 54.3885 56.6135 54.3885H19.9546C19.1858 54.3885 18.5625 53.7652 18.5625 52.9964C18.5625 52.2275 19.1858 51.6042 19.9546 51.6042H56.6135C57.3824 51.6042 58.0057 52.2275 58.0057 52.9964Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.4047 62.2747C46.4047 63.0435 45.7815 63.6668 45.0126 63.6668H19.9546C19.1858 63.6668 18.5625 63.0435 18.5625 62.2747C18.5625 61.5058 19.1858 60.8826 19.9546 60.8826H45.0126C45.7815 60.8826 46.4047 61.5058 46.4047 62.2747Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.4047 71.5559C46.4047 72.3248 45.7815 72.948 45.0126 72.948H19.9546C19.1858 72.948 18.5625 72.3248 18.5625 71.5559C18.5625 70.7871 19.1858 70.1638 19.9546 70.1638H45.0126C45.7815 70.1638 46.4047 70.7871 46.4047 71.5559Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.1493 97.5828H2.9806C1.33446 97.5828 -0.0183847 98.9194 0.0876356 100.562C0.499537 106.944 2.41927 110.083 7.01624 111.615H63.1462C63.1462 111.615 57.4742 108.779 56.3298 100.557C56.1028 98.9271 54.7955 97.5828 53.1493 97.5828Z",
			fill: "#A9AFBB"
		})
	]
});
export default SvgIcEmptyAnalysis;
